export default {
    /**
     * Changes UI state
     *
     * @param   {object}  state    Vuex state.
     * @param   {object}  newState New UI state.
     *
     */
    changeUIState(state, newState) {
        state.UIState = {
            ...state.UIState,
            ...newState,
        };
    },

    /**
     * Sets invoices
     *
     * @param   {object}   state     Vuex state.
     * @param   {Array}  invoices  Invoices list.
     */
    setInvoices(state, invoices) {
        state.invoices = invoices;
    },

    /**
     * Sets user card
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   card  User card.
     *
     */
    setUserCard(state, card) {
        state.userCard = card ? { ...card } : card;
    },

    /**
     * Sets payment methods.
     *
     * @param   {object}  state    Vuex state.
     * @param   {Array}   methods  Payment methods.
     *
     */
    setPaymentMethods(state, methods) {
        state.paymentMethods = methods ? [...methods] : methods;
    },

    /**
     * Sets user plan
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   plan  User plan.
     *
     */
    replaceUserPlan(state, plan) {
        state.userPlans[0] = plan;
    },

    /**
     * Sets user subscriptions
     * This is a Stripe subscription object.
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   subscription  User plan.
     */
    setUserSubscription(state, subscription) {
        state.userSubscription = subscription;
    },

    /**
     * Sets currently selected subscriptions
     * This is a laravel Subscription model.
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   subscription  User plan.
     */
    setCurrentSubscription(state, subscription) {
        state.currentSubscription = subscription;
    },

    /**
     * Sets upcoming invoice
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   invoice  User plan.
     */
    setUpcomingInvoice(state, invoice) {
        state.upcomingInvoice = invoice;
    },

    /**
     * Sets presumed invoice
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   invoice  User plan.
     */
    setPresumedInvoice(state, invoice) {
        state.presumedInvoice = invoice;
    },

    /**
     * Save presumed invoice as upcomming.
     *
     * @param   {object}   state Vuex state.
     */
    savePresumedInvoice(state) {
        state.upcomingInvoice = { ...state.presumedInvoice };
    },

    /**
     * Sets billing plans
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   data   Array with billing plans.
     *
     */
    setBillingPlans(state, data) {
        state.billingPlans = data;
    },

    /**
     * Sets billing summary
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   data   Array with billing summary.
     *
     */
    setBillingSummary(state, data) {
        state.billingSummary = data;
    },

    /**
     * Sets plan features.
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   data   Array with plan features.
     *
     */
    setPlanFeatures(state, data) {
        state.planFeatures = data;
    },
};
